/**
 * niceScale — 축 min/max를 "0/5/10 단위" 라운드된 보기 좋은 값으로 변환.
 * 예: niceScale(22, 47) → { min: 20, max: 50, ticks: [20,25,30,35,40,45,50] }
 */
export function niceScale(min: number, max: number, maxTicks = 5): {
  min: number;
  max: number;
  ticks: number[];
} {
  if (!isFinite(min) || !isFinite(max)) {
    return { min: 0, max: 100, ticks: [0, 25, 50, 75, 100] };
  }
  if (min === max) {
    const m = min;
    const span = Math.max(Math.abs(m) * 0.2, 10);
    min = m - span;
    max = m + span;
  }
  const range = max - min;
  const roughStep = range / (maxTicks - 1);
  const exp = Math.floor(Math.log10(Math.abs(roughStep) || 1));
  const base = Math.pow(10, exp);
  const norm = roughStep / base;
  let niceStep: number;
  if (norm < 1.5) niceStep = 1 * base;
  else if (norm < 3) niceStep = 2 * base;
  else if (norm < 7) niceStep = 5 * base;
  else niceStep = 10 * base;
  const niceMin = Math.floor(min / niceStep) * niceStep;
  const niceMax = Math.ceil(max / niceStep) * niceStep;
  const decimals = Math.max(0, -Math.floor(Math.log10(niceStep)));
  const ticks: number[] = [];
  for (let v = niceMin; v <= niceMax + niceStep / 2; v += niceStep) {
    ticks.push(parseFloat(v.toFixed(decimals)));
  }
  return { min: niceMin, max: niceMax, ticks };
}
